var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"right"}},[_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":this.url,"title":"Impressão da nota de crédito","allow":"fullscreen"}}),_c('v-btn',{on:{"click":function($event){return _vm.Voltar()}}},[_vm._v("Fechar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }